module.exports = __webpack_public_path__ + "static/media/savio34.fd84e71c.jpg";